import React, { Component } from 'react';
import Link from 'react-router-dom/Link';
import classNames from 'classnames';
import MDSpinner from 'react-md-spinner';

import './styles.css';

/**
 * A simple button component.
 *
 * @typedef {Object} Props
 * @prop {boolean} [disabled]
 * @prop {boolean} [submitting]
 * @prop {Function} [onClick]
 * @prop {String} [className]
 * @prop {String} [href]
 * @prop {String} [type]
 * @prop {boolean} [arrowDown]
 * @prop {boolean} [arrowUp]
 *
 * @augments {Component<Props>}
 */
export default class Button extends Component {
	genClassName = (props) =>
		classNames('Button', props.className, {
			'Button-link': props.href,
		});

	/** @param {React.SyntheticEvent} event */
	handleClick = (event) => this.props.onClick && this.props.onClick(event);

	renderLink = (href, className) => {
		const { children } = this.props;
		return href.includes('http') ? (
			<a className={className} href={href}>
				{children}
			</a>
		) : (
			<Link className={className} to={href}>
				{children}
			</Link>
		);
	};

	render () {
		const {
			children,
			disabled,
			href,
			submitting,
			type,
			arrowDown,
			arrowUp,
		} = this.props;
		const className = this.genClassName(this.props);
		const upOrDownArrow = (arrowDown || arrowUp) && (
			<span className={'Arrow'}>
				{arrowDown ? <span>&#8595;</span> : <span>&#8593;</span>}
			</span>
		);

		return href ? (
			this.renderLink(href, className)
		) : (
			<button
				className={className}
				disabled={disabled || submitting}
				onClick={this.handleClick}
				type={type}
			>
				{upOrDownArrow}
				{submitting ? (
					<MDSpinner singleColor='white' size={18} />
				) : (
					children
				)}
			</button>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atoms/Button/Button.js